import React from "react";

interface ExpandCollapseButtonProps {
  isExpanded: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * Button component that toggles between collapse and expand states
 */
const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({
  isExpanded,
  onClick,
  className = "",
}) => {
  return (
    <button
      className={className}
      onClick={onClick}
      aria-label={isExpanded ? "Collapse" : "Expand"}
    >
      {isExpanded ? (
        // Collapse icon (arrows pointing inward)
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="var(--icon)"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 9H9V3"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 15H15V21"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 3L3 9"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 21L21 15"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        // Expand icon (arrows pointing outward)
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="var(--icon)"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 3H21V9"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 21H3V15"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 3L14 10"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 21L10 14"
            stroke="var(--icon)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
};

export default ExpandCollapseButton;
